import Swiper from 'swiper/bundle';
export function initializeCarouselFeed() {
  var swiperFeed = new Swiper('.feed-section', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next-unique',
      prevEl: '.swiper-button-prev-unique'
    },
    speed: 800,
    effect: 'slide',
    breakpoints: {
      1600: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1281: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      0: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0
      }
    }
  });
}